<template>
   <div class='ol-popup'>
      <span class='ol-popup-closer' @click="close" title='Close'>&#10005;</span>
      <div class='header'> Feasible Energy Techonology </div>
      <div class='ol-content'>
         <div v-if="getPointQueryResult" class="result">
            <div class='title'>
               <span>Energy</span>
               <span>Feasibility</span>
            </div>
            <div v-for="([energyTechnology, isFeasible],index) in Object.entries(getPointQueryResult)" :key="index">
               <span>{{ energyTechnology }}</span>
               <span
                  class="feasibility"
                  :class="{'is-feasible': isFeasible}"
                  >
                  {{ isFeasible ? '&#10004;' :'&#10007;'}}
               </span>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { setPointToolResultPopupTarget, closeBATPointQueryOverlay } from '../../../../js/tools/bat';
import { mapGetters } from 'vuex';

export default {
   computed: {
      ...mapGetters('tools', ['getPointQueryResult']),
   },
   mounted()
   {
      setPointToolResultPopupTarget(document.querySelector('.ol-popup'));
   },
   beforeDestroy()
   {
      setPointToolResultPopupTarget(null);
   },
   methods: {
      close()
      {
         closeBATPointQueryOverlay();
      }
   }
}
</script>

<style lang="scss" scoped>
.ol-popup {
   $border-radius: 5px;
   @include setBlurGlassBackground();
   background: rgba(white, 0.6);
   padding: 0;
   border: none;
   border-radius: $border-radius;
   position: absolute;
   box-shadow: 0 1px 4px rgba(158, 121, 121, 0.2);
   bottom: 12px;
   left: -50px;
   min-width: 280px;
   z-index: 1;
   cursor: default;
   &:after{
      background: rgba(white, 0.7);
      backdrop-filter: blur(10px);
      position: absolute;
      top: 100%;
      left: 40px;
      content: " ";
      height: 10px;
      width: 20px;
      clip-path: polygon(50% 100%, 0 0, 100% 0);
      z-index: 1;
      box-shadow: 1px 5px 3px rgba(black, 1);
      pointer-events: none;
   }

   .ol-popup-closer {
      text-decoration: none;
      position: absolute;
      top: 8px;
      right: 8px;
      cursor: pointer;
      color: rgba(white,0.9);
      width: 18px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.3s linear;
      border-radius: 50%;
      &:hover {
         color: saturate($danger-color, 100%);
         background: rgba($light-color, 0.4);
      }
   }

   .header {
      background: $primary-color;
      color: white;
      padding: 6px 10px;
      border-radius: $border-radius $border-radius 0 0;
      font-family: $primary-font;
   }

   .ol-content {
      font-family: $primary-font;
      padding: 5px 10px;
      color: $font-color;
      .result {
         div span {
            display: inline-block;
            width: 50%;
            font-size: 14.5px;
         };
         .title {
            span {
               font-size: 15px;
               font-weight: 600;
               color: $dark-color;
               &:last-child {
                  text-align: center;
               }
            }
         }
         
         .feasibility {
            text-align: center;
            color: $danger-color;
            &.is-feasible {
               color: $success-color;
            }
         }
      }
   }
}
</style>